import Categories from "../../components/home/Categories";
import HomeProduct from "../../components/home/HomeProduct";
import HomeBanner from "../../components/home/HomeBanner";
import HomeEditorial from "../../components/home/HomeEditorial";
import CampaignRenderer from "../../components/home/CampaignRenderer";
import Slider from "../../components/home/Slider";
import Nav from "../../components/home/Nav";
import Spinner from "../../components/Spinner";
import TrustSection from "../../components/home/landing/TrustSection";
import Footer from "../../components/home/landing/Footer";
import { useHomepageQuery } from "../../store/services/homepageService";

const HomeSection = ({ section }) => {
  if (section.type === "categories") {
    return (
      <section className="home-dynamic-section home-category-section">
        <Categories settings={section.settings} />
      </section>
    );
  }

  if (
    section.type === "latest_products" ||
    section.type === "special_offer" ||
    section.type === "featured_products" ||
    section.type === "category_products" ||
    section.type === "popular_products"
  ) {
    return <HomeProduct section={section} />;
  }

  if (section.type === "banner") {
    return <HomeBanner section={section} />;
  }

  if (section.type === "editorial") {
    return <HomeEditorial section={section} />;
  }

  return null;
};

const Home = () => {
  const { data, isFetching } = useHomepageQuery();

  const sections = data?.sections || [];
  const slides = data?.slides || [];
  const campaigns = data?.campaigns || {};

  return (
    <>
      <Nav />

      <main className="site-main">
        {isFetching ? (
          <div className="hero-loading">
            <Spinner />
          </div>
        ) : (
          <>
            <CampaignRenderer campaigns={campaigns} placement="home" types={["hero", "banner", "popup"]} />

            <Slider slides={slides} />

            <section className={slides.length ? "home-section home-section-after-slider" : "home-section home-section-without-hero"}>
              <div className="site-container">
                {sections.map((section) => (
                  <HomeSection section={section} key={section.id} />
                ))}
              </div>
            </section>

            <div className="site-container">
              <TrustSection />
            </div>

            <Footer />
          </>
        )}
      </main>
    </>
  );
};

export default Home;
